import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-save",
  "use": "rt-portal-save-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-save\"><defs><style type=\"text/css\"></style></defs><path d=\"M829.44 0H128C56.32 0 0 56.32 0 128v768C0 967.68 56.32 1024 128 1024h768c71.68 0 128-56.32 128-128V194.56L829.44 0zM563.2 102.4v204.8H358.4V102.4h204.8z m358.4 793.6c0 15.36-10.24 25.6-25.6 25.6h-768c-15.36 0-25.6-10.24-25.6-25.6v-768c0-15.36 10.24-25.6 25.6-25.6H256v204.8c0 56.32 46.08 102.4 102.4 102.4h204.8c56.32 0 102.4-46.08 102.4-102.4V102.4h122.88L921.6 235.52v660.48z\" p-id=\"10333\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/save.svg
// module id = 707
// module chunks = 99